import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function LocationModal({
  createLocation,
  getLocationList,
  history,
  getSingleLocation,
  barangayList,
  getBarangayList,
  type,
  updateLocation,
  updateList,
  locationId,
  getDistrictList,
  districtList,
}) {
  const [formData, setFormData] = useState({
    name: '',
    rptax_district_id: '',
    rptax_barangay_id: '',
  });
  const validateForm = useFormValidator(formData, {
    name: 'required',
    rptax_district_id: 'required',
  });

  useEffect(() => {
    getDistrictList();
  }, []);

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createLocation(formData, ({ data }) => {
        setModal({ isOpen: false });
        getLocationList();
        history.push(
          `/rpt/settings/property-locations/locations/${_.get(data, 'id')}`
        );
        getSingleLocation(data.id);
      });
    }

    if (type === 'EDIT') {
      updateLocation(locationId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getLocationList();
        history.push(
          `/rpt/settings/property-locations/locations/${_.get(data, 'id')}`
        );
        getSingleLocation(data.id);
      });
    }


  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
      getBarangayList({ rptax_district_id: _.get(updateList, 'rptax_district_id') })
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const barangayOptions = barangayList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const districtOptions = districtList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleSelected = key => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
    if (key === 'rptax_district_id') {
      getBarangayList({ rptax_district_id: e.value })
    }
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">District Name {validateForm.renderMessage('rptax_district_id')} </label>
            <div>
              <Select
                options={districtOptions}
                styles={customStyle}
                placeholder="Select District"
                value={districtOptions.filter(item => +_.get(formData, 'rptax_district_id') === +_.get(item, 'id')) || ''}
                onChange={handleSelected('rptax_district_id')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Barangay</label>
            <div>
              <Select
                options={barangayOptions}
                styles={customStyle}
                placeholder="Select Barangay"
                value={barangayOptions.filter(item => +_.get(formData, 'rptax_barangay_id') === +_.get(item, 'id')) || ''}
                onChange={handleSelected('rptax_barangay_id')}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

LocationModal.defaultProps = {
  type: '',
  updateList: {},
  locationId: '',
}

LocationModal.propTypes = {
  type: PropTypes.string,
  locationId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getLocationList: PropTypes.instanceOf(Function).isRequired,
  createLocation: PropTypes.instanceOf(Function).isRequired,
  updateLocation: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleLocation: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  barangayList: _.get(api, `${c.GET_BARANGAY_LIST}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICT_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(LocationModal);
